var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item-rows-container",on:{"click":_vm.handleClick}},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('menu-item-row',{attrs:{"hasDiscount":_vm.hasDiscount,"item":item,"linked":true}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219b493a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/common/MenuItemRows.vue
// module id = null
// module chunks = 